import React           from 'react';
import StatusLabel     from '../StatusLabel';
import PropTypes       from '../PropTypes';
import ComponentHelper from '../../helper/ComponentHelper';

class TableStatusFormatter extends React.Component {
    render () {
        return (
            <StatusLabel
                value={this.props.value}
            />
        );
    }

    shouldComponentUpdate (nextProps, nextState) {
        return ComponentHelper.shouldComponentUpdate(
            this,
            Component,
            nextProps,
            nextState,
        );
    }
}

const Component = TableStatusFormatter;

Component.propTypes = {
    value: PropTypes.any,
};

Component.defaultProps = {
    value: [],
};

Component.renderAffectingProps = Object.keys(Component.defaultProps);

Component.renderAffectingStates = [];

export default Component;